import { isNilOrNaN } from '@yoop/util';

export const isNilOrZero = (value: number | undefined | null): value is undefined | null | 0 =>
  isNilOrNaN(value) || value === 0;
